import ChangePassword from "@/views/App/Security/ChangePassword.vue";
import ChangePasswordForUser from "@/views/App/User/ChangePassword/Form.vue";
import UserBasicInfo from "@/views/App/User/BasicInformation/BsicInformation.vue";
import UserProfile from "@/views/App/User/Profile/Profile.vue";

const routesSecurity = [
    {
        path: 'change-password',
        name: 'changePassword',
        component: ChangePassword
    },
    {
        path: 'change-password-for-user/:id',
        name: 'changePasswordForUser',
        component: ChangePasswordForUser
    },
    {
        path: 'user-profile',
        name: 'userProfile',
        component: UserProfile
    },
];

export default routesSecurity;